let _id = 0;
const _subs = [];

export function showToast(message, type = 'error') {
  const id = ++_id;
  _subs.forEach(fn => fn({ id, message, type }));
}

export function _subscribe(fn) {
  _subs.push(fn);
  return () => {
    const i = _subs.indexOf(fn);
    if (i >= 0) _subs.splice(i, 1);
  };
}
